import { useState } from "react";

import { useDocumentTypes } from "features/documents/hooks/useDocumentTypes";

export const useActiveDocumentType = () => {
  const { data: documentTypes = [], isLoading } = useDocumentTypes();
  const [activeType, setActiveType] = useState("ALL");

  const enabledTypes = documentTypes.filter((dt) => !dt.disabled);

  return { documentTypes: enabledTypes, isLoading, activeType, setActiveType };
};
